import React, { useCallback } from 'react'
import classNames from 'classnames'
import { Else, If, Then } from 'react-if'
import { CaptionLG } from '@/atoms/Text'
import { Offer } from '@/services/PifService'
import { getPeopleImpacted } from '@/services/PifService/PifService'
import { formatPrice } from '@/services/PriceFormatter'
import { useLocale } from '@/utils/LocaleUtil'

interface TheatricalExpressPriceOptionsProps {
  offers: Offer[]
  onClick: (offer: Offer) => void
  selectedOffer: Offer | undefined
  shouldShowPeopleImpacted?: boolean
  shouldUseEqualColumns?: boolean
}

export const TheatricalExpressPriceOptions: React.FC<TheatricalExpressPriceOptionsProps> = ({
  offers,
  onClick,
  selectedOffer,
  shouldShowPeopleImpacted = true,
  shouldUseEqualColumns = false,
}) => {
  const { locale } = useLocale()

  const getReach = useCallback(
    (offer: Offer) => {
      const num = getPeopleImpacted(offer)
      return new Intl.NumberFormat(locale, { notation: 'compact' }).format(num)
    },
    [locale],
  )

  return (
    <>
      <If condition={shouldUseEqualColumns}>
        <Then>
          <div className="mt-6 grid grid-cols-4 gap-1">
            {offers?.map((offer) => {
              const price = formatPrice(offer.price, { includeDecimals: false, currency: offer.currency })
              return (
                <div
                  key={offer?.id}
                  className="flex-basis-auto shrink-0 grow cursor-pointer text-center"
                  onClick={() => onClick(offer)}
                >
                  <CaptionLG
                    weight="bold"
                    className={classNames(
                      offer.id === selectedOffer?.id
                        ? 'border-gray-800 bg-gray-800 text-white'
                        : 'border-gray-200 bg-gray-100',
                      'rounded-lg border-2 p-2',
                    )}
                  >
                    {shouldShowPeopleImpacted ? getReach(offer) : price}
                  </CaptionLG>
                </div>
              )
            })}
          </div>
        </Then>
        <Else>
          <div className="mt-6 flex flex-wrap gap-1">
            {offers?.map((offer) => {
              const price = formatPrice(offer.price, { includeDecimals: false, currency: offer.currency })
              return (
                <div
                  key={offer?.id}
                  className="flex-basis-auto shrink-0 grow cursor-pointer text-center"
                  onClick={() => onClick(offer)}
                >
                  <CaptionLG
                    weight="bold"
                    className={classNames(
                      offer.id === selectedOffer?.id
                        ? 'border-gray-800 bg-gray-800 text-white'
                        : 'border-gray-200 bg-gray-100',
                      'rounded-lg border-2 p-2',
                    )}
                  >
                    {shouldShowPeopleImpacted ? getReach(offer) : price}
                  </CaptionLG>
                </div>
              )
            })}
          </div>
        </Else>
      </If>
    </>
  )
}
